import React from 'react';
import { WorkspaceManagement } from '../features/workspaces';

/**
 * WorkspacesPage - Página de gestão do workspace único do usuário
 *
 * No modelo 1:1 User:Workspace, cada usuário tem exatamente 1 workspace.
 * Esta página mostra as configurações e gestão do workspace único.
 */
export const WorkspacesPage: React.FC = () => {
  return <WorkspaceManagement />;
};

export default WorkspacesPage;
